import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { eventsT5, next_matches_url, divisionsT5 } from "../utils/constants";
import axios from "axios";
import { MatchSummary } from "../components";

const Temp5Page = () => {
  const [nextMatchesLoading, setNextMatchesLoading] = useState(true);
  const [nextMatchesError, setNextMatchesError] = useState(false);
  const [nextMatches, setNextMatches] = useState([]);

  useEffect(() => {
    async function fetchData() {
      setNextMatchesLoading(true);
      setNextMatchesError(false);
      try {
        const response = await axios.get(next_matches_url);
        setNextMatchesLoading(false);
        if (response.status === 200) {
          console.log(response.data);
          setNextMatches(response.data);
        } else {
          setNextMatchesError(true);
        }
      } catch (error) {
        setNextMatchesLoading(false);
        setNextMatchesError(true);
      }
    }
    fetchData();
  }, []);

  const now = new Date(new Date().setHours(0, 0, 0, 0));
  const filteredEvents = eventsT5.filter((event) => {
    const eventDate = new Date(new Date(event.date).setHours(0, 0, 0, 0));
    return eventDate.getTime() >= now.getTime();
  });

  const first_event =
    filteredEvents && filteredEvents[0] ? filteredEvents[0].date : "";
  console.log(first_event);
  const first_event_date = first_event
    ? new Date(new Date(first_event).setHours(0, 0, 0, 0))
    : new Date();

  console.log(now);
  console.log(first_event_date);
  console.log(now.getTime() === first_event_date.getTime());

  const getMonthName = (month) => {
    if (month === 0) return "Ene";
    if (month === 1) return "Feb";
    if (month === 2) return "Mar";
    if (month === 3) return "Abr";
    if (month === 4) return "May";
    if (month === 5) return "Jun";
    if (month === 6) return "Jul";
    if (month === 7) return "Ago";
    if (month === 8) return "Sep";
    if (month === 9) return "Oct";
    if (month === 10) return "Nov";
    if (month === 11) return "Dic";
  };

  console.log(filteredEvents);
  return (
    <Wrapper>
      <div className="column-1">
        <article>
          <h1 className="special-title">Calendario</h1>
          <div className="timeline">
            {filteredEvents.length > 0 ? <div className="line"></div> : ""}
            <ul>
              {filteredEvents.length === 0 ? <p>La liga ha terminado</p> : ""}
              {filteredEvents.length > 0 &&
              now.getTime() !== first_event_date.getTime() ? (
                <li className="today">
                  <span className="dot-today"></span>
                  <span>
                    <b>HOY</b>
                  </span>
                  <span>{`${now.getDate()}/${getMonthName(
                    now.getMonth()
                  )}`}</span>
                  <span>&nbsp;</span>
                </li>
              ) : (
                ""
              )}
              {filteredEvents.map((event, index) => {
                const event_date = new Date(
                  new Date(event.date).setHours(0, 0, 0, 0)
                );
                const today = now.getTime() === event_date.getTime();

                if (index > 3) {
                  return "";
                }
                return (
                  <li key={event.eventId}>
                    <span className={today ? "dot-today" : "dot"}></span>
                    <span>
                      <b>
                        {today
                          ? "HOY"
                          : `${new Date(event.date).getDate()}/${getMonthName(
                              new Date(event.date).getMonth()
                            )}`}
                      </b>
                    </span>
                    {event.eventDescs.map((desc, index) => {
                      return (
                        <span key={`${event.eventId}-${index}`}>{desc}</span>
                      );
                    })}
                    {event.eventDescs.length === 1 ? <span>&nbsp;</span> : ""}
                    <span></span>
                  </li>
                );
              })}
            </ul>
          </div>
        </article>

        <article>
          <h1 className="special-title">Clasificaciones</h1>
          <div className="divisions">
            {divisionsT5.map((div) => {
              if (div.groups.length === 0) {
                return (
                  <div className="division" key={`division-${div.id}`}>
                    <Link to={div.link}>
                      <img src={div.image} alt={div.name} />
                    </Link>
                    <Link to={div.link}>
                      <span>{div.name}</span>
                    </Link>
                  </div>
                );
              }

              return (
                <div className="division" key={`division-${div.id}`}>
                  <img src={div.image} alt={div.name} />
                  <span>{div.name}</span>
                  <div className="groups">
                    {div.groups.map((group, key) => {
                      return (
                        <div
                          className="group"
                          key={`division-${div.id}-group-${key}`}
                        >
                          <Link to={group.link}>{group.name}</Link>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </article>
      </div>
      <div className="column-2">
        <article>
          <div className="search-player"></div>
        </article>
        <article>
          <Link to="playoffs-t5">
            <img
              src="https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/playoffs_banner.png"
              alt=""
              style={{ width: "60%", border: "solid 2px var(--clr-primary)" }}
            />
          </Link>
        </article>
        <article>
          <h1 className="special-title">Links</h1>
          <div className="links">
            <ul>
              <li>
                <Link to="info-temporada-5">&gt; Info T5</Link>
              </li>
              <li>
                <a
                  href="https://docs.google.com/document/d/1Ke2XnHp1fUVNx5ykehunuPAZw5NqVEHq/edit?usp=sharing&ouid=101891344918082115048&rtpof=true&sd=true"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  &gt; Handbook
                </a>
              </li>
              <li>
                <a
                  href="https://aoe2cm.net/preset/XQmqK"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  &gt; Pick mapas
                </a>
              </li>
              <li>
                <a
                  href="https://www.aoe2cm.net/preset/ahTRl"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  &gt; Pick civis
                </a>
              </li>
            </ul>
          </div>
        </article>
        <article>
          <h1 className="special-title">Prox Partidas</h1>
          <div className="next-games">
            {nextMatchesLoading ? (
              <p>Cargando próximos partidos...</p>
            ) : (
              nextMatches.map((match) => {
                return (
                  <MatchSummary key={`nextmatches-${match.id}`} {...match} />
                );
              })
            )}
            {nextMatchesError ? <p>Error cargando próximos partidos</p> : ""}
          </div>
        </article>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  display: flex;
  flex-direction: row;

  .next-games {
    display: flex;
    flex-wrap: wrap;
    max-height: 45rem;
    overflow: auto;
    width: 80%;
  }

  .next-games::-webkit-scrollbar {
    -webkit-appearance: none;
  }

  .next-games::-webkit-scrollbar:vertical {
    width: 10px;
  }

  .next-games::-webkit-scrollbar-button:increment,
  .next-games::-webkit-scrollbar-button {
    display: none;
  }

  .next-games::-webkit-scrollbar:horizontal {
    height: 10px;
  }

  .next-games::-webkit-scrollbar-thumb {
    background-color: #797979;
    border-radius: 20px;
    border: 2px solid #f1f2f3;
  }

  .next-games::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  // Calendar  ============ START
  .today {
  }
  .dot-today {
    position: relative;
    top: -10%;
    height: 18px;
    width: 18px;
    background-color: var(--clr-violet);
    border-radius: 50%;
    display: inline-block;
    border: solid 1px var(--clr-grey-1);
  }

  .timeline {
    background-color: var(--clr-primary);
    margin: 2rem;
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .timeline .line {
    border-top: 1px solid var(--clr-grey-1);
    width: 100%;
  }

  .timeline ul {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }

  .timeline ul li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .dot {
    position: relative;
    top: -10%;
    height: 18px;
    width: 18px;
    background-color: var(--clr-grey-1);
    border-radius: 50%;
    display: inline-block;
  }
  // Calendar  ============ END

  .links ul {
    margin-left: 2rem;
  }
  .cards-container {
    display: flex;
  }

  .column-1 {
    width: 60%;
  }

  // Divisions ============ START
  .divisions {
    display: flex;
    flex-wrap: wrap;
  }
  .division {
    border: 1px solid var(--clr-grey-1);
    border-radius: 8px;
    width: 28%;
    margin: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1rem;
  }
  .division img {
    width: 4rem;
  }
  .groups {
    display: flex;
    flex-direction: row;
  }
  .group {
    background-color: var(--clr-violet);
    color: var(--clr-grey-1);
    padding: 0.5rem;
    border-radius: 100%;
    margin: 0.2rem;
    cursor: pointer;
  }
  // Divisions ============ END

  .column-2 {
    width: 40%;
  }

  @media (max-width: 920px) and (min-width: 860px) {
    display: flex;
    flex-direction: column;
    .divisions {
      justify-content: space-evenly;
    }
    .division {
      margin: 0.3rem;
      padding: 0.8rem;
    }
    .groups {
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }

  @media (max-width: 860px) {
    display: flex;
    flex-direction: column;

    .column-1,
    .column-2 {
      width: 100%;
    }

    .divisions {
      justify-content: space-evenly;
    }
    .division {
      width: 40%;
    }

    .next-games {
      max-height: fit-content;
      width: 100%;
      justify-content: center;
    }

    .timeline {
      margin: 0;
    }
  }
`;
export default Temp5Page;
